import { render, staticRenderFns } from "./AgentChatbox.vue?vue&type=template&id=29c69c01&scoped=true"
import script from "./AgentChatbox.vue?vue&type=script&lang=ts"
export * from "./AgentChatbox.vue?vue&type=script&lang=ts"
import style0 from "./AgentChatbox.vue?vue&type=style&index=0&id=29c69c01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c69c01",
  null
  
)

export default component.exports